export default __webpack_public_path__ + "static/media/gallery-wip-neck_11.c4c7981a.jpg";